const mbg_en = {
    common: {
        account_name: 'account name',
        account_number: 'account number',
        kitchen: "kitchen",
        ktp: 'KTP',
        project: 'project',
        region: 'region',
        balance_active: 'active balance',
        balance_pending: 'pending balance',
        balance_total: 'total balance',
        supplier: "supplier",
        zip: 'post code',
    },
    menu: {
        so: "sales order (SO)",
        do: "delivery order (DO)",
        funding: 'bill',
        kitchen: "kitchen",
        project: 'project',
        project_list: 'project list',
        request: 'sale',
        supplier: "supplier",
        notif_price: "price changes",
    },
    funding: {
        "date": "date",
        "detail": "funding detail",
        "due_date": "due date",
        "invoice": "invoice number",
        "po": "PO number",
        "pdf": "view PDF",
    },
    kitchen: {
        "name": "kitchen name",
        "pic": "PIC warehouse kitchen",
        "phone": "kitchen phone",
        "fax": "kitchen fax",
        "email": "kitchen email",
        "add": "add kitchen",
        "edit": "edit kitchen",
        "logo": "kitchen logo",
    },
    project: {
        "name": "project name",
        "date": "project date",
        "date_new_end_date": "new project end date",
        'add': "add project",
        'edit': "edit project",
        "extend": "extend project",
        'view': "detail project",
        "kitchen": "list of project kitchens",
        "add_kitchen": "add kitchen",
        "edit_kitchen": "edit kitchen",
        "delete_kitchen": "delete kitchen",
    },
    request: {
        "detail": "sale detail"
    },
    supplier: {
        "name": "supplier name",
        "pic": "PIC warehouse supplier",
        "phone": "supplier phone",
        "fax": "supplier fax",
        "email": "supplier email",
        "add": "add supplier",
        "edit": "edit supplier",
        "logo": "supplier logo",
        "sku": "supplier SKU",
        "add_sku": "add supplier SKU",
        "edit_sku": "edit supplier SKU",
    },
    notif_price: {

    }
}
export default mbg_en;